export default "<notifier-container></notifier-container>\r\n<router-outlet></router-outlet>\r\n";